/**
 * RESPONSIBILITY: the breadcrumb trail, and the way back.
 *
 * Every page below the top level has one. The trail is passed in rather than derived,
 * because only the page knows what it sits under.
 */
import { Page, hrefFor } from './pages';
import { useWords, useWordsEdit } from './words';

export interface Crumb { label: string; page?: Page; id?: string }

export function Crumbs({ trail }: { trail: Crumb[] }) {
  const w = useWords();
  const edit = useWordsEdit();

  return (
    <nav className="crumbs" aria-label="Breadcrumb">
      <div className="wrap">
        <a href={hrefFor(Page.Home)}>{w.homeLabel}</a>
        {trail.map((c) => (
          <span key={c.label}>
            <span className="sep">/</span>
            {c.page ? <a href={hrefFor(c.page, c.id)}>{c.label}</a> : <span className="here">{c.label}</span>}
          </span>
        ))}
        <a className="back" href={hrefFor(Page.Home)}>{w.backLabel}</a>
        {/* These words belong to no page, so this is the only place they can be reached
            from. Beside the trail they name, rather than in a corner of the site. */}
        {edit.canEdit && (
          <button type="button" className="crumbs-edit" onClick={edit.open}
                  title="Edit the site’s wording" aria-label="Edit the site’s wording">✎</button>
        )}
      </div>
    </nav>
  );
}
